import { render, staticRenderFns } from "./BlocAuthenticated.vue?vue&type=template&id=6c3604f2&"
import script from "./BlocAuthenticated.vue?vue&type=script&lang=js&"
export * from "./BlocAuthenticated.vue?vue&type=script&lang=js&"
import style0 from "./BlocAuthenticated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports